import { nanoid } from 'nanoid';

const CONSTANTS = {
  SKYROOM_SUPPORT_URL: 'https://skyroom.online/support',
  SIDEBAR_ID: nanoid(),
  BREAKPOINTS: {
    XS: 600,
    SM: 960,
    MD: 1264,
  },
  TOAST_DEFAULT_TIMEOUT: 7000,
  PAGE_SIZES: [
    { label: '10', value: 10 },
    { label: '50', value: 50 },
    { label: '100', value: 100 },
  ],
  TICKET_MESSAGE_MAX_CHARACTERS: 1000,
  NOTIFICATIONS_STATUS_LOCAL_STORAGE_KEY: 'nslsk',
  LOCALE_LOCAL_STORAGE_KEY: 'llsk',
  DONT_SHOW_USERS_IMPORT_FEATURE_MODAL_LOCAL_STORAGE_KEY: 'dsuifmlsk',
  DONT_SHOW_SERVICE_CHANGE_WARNING: 'don_not_show_service_change_warning',
  DEFAULT_PAGE_SIZE: 10,
  DEFAULT_PAGE: 1,
  DEFAULT_VIRTUAL_SCROLL_CHUNK: 50,
  AUTH_CODE_RESEND_TIMEOUT_IN_SECONDS: 120,
  PASSWORD_HINT_SPACIAL_CHARACTERS: '!@#$%^&*',
  REGEX: {
    VALID_URL: /^[a-zA-Z0-9_.-]+$/,
    URL: /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,63}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/,
    EMAIL: /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
    CHANNEL_SHORT_ADDRESS: /^[a-zA-Z0-9_.-]+$/,
    PHONE: /^[0-9]{4,}$/,
    AUTH_USERNAME: /^[a-zA-Z][a-zA-Z0-9-_@.]*$/,
    USERNAME: /^[a-zA-Z0-9-_@.]+$/,
    MOBILE: /^\d{7,15}$/,
    SIGN_IN_PASSWORD: /^[\x20-\x7E]{3,24}$/,
    SIGN_UP_PASSWORD: /^(?=.*[@!#$%&*()\-+=])[A-Za-z0-9@!#$%&*()\-+=]{8,24}$/,
    CREATE_USER_PASSWORD: /^[\x21-\x7E]{3,24}$/,
    NATIONAL_CODE: /^[0-9]{10}$/,
    POSTAL_CODE: /^\d{10}$/,
    NATIONAL_ID: /^\d{11}$/,
    REGISTRATION_NUMBER: /^\d/,
    ECONOMIC_CODE: /^\d{14}$/,
    PERSIAN_CHARACTERS: /^[؀-۠\s]+$/,
    YES_NO_BOOLEAN: /^yes$|^no$/,
    PERSIAN_ALPHABETIC: /^[\u0600-\u06FF\s]+$/,
  },
  API_ENTITY_URLS: {
    CHANNELS: 'channels',
    SERVICES: 'services',
    USERS: 'users',
    USER: 'user',
    FILES: 'files',
    STATS: 'stats',
    SESSIONS: 'sessions',
    CONNECTIONS: 'connections',
    NOTIFICATIONS: 'notifications',
    RECORDINGS: 'recordings',
    RECORD: 'record',
    INVOICES: 'invoices',
    TICKETING: 'ticketing',
    SETTINGS: 'settings',
    AUTH: 'auth',
    ACCOUNTS: 'accounts',
    SKYROOM: 'skyroom',
    BACKUP_LOGS: 'backup-logs',
    BANNERS: 'banners',
  },
  COOKIE: {
    ACCESS_TOKEN: 'ACCESS_TOKEN',
    XSRF_TOKEN: 'XSRF-TOKEN',
  },
  LOCALSTORAGE: {
    ATTENDEES_FEATURE_MODAL: 'ATTENDEES_FEATURE_MODAL',
    VERIFY_USER: 'VERIFY_USER',
    LAST_NOTIFICATION_ID: 'LAST_NOTIFICATION_ID',
  },
  NOTIFICATION: {
    DEFAULT_NOTIFICATION_ID: 11,
  },
};

export default Object.freeze(CONSTANTS);
